export const SET_IS_FETCHING_CHANNELS = 'STATUS/SET_IS_FETCHING_CHANNELS';
